/* HEAVELYN — global.js
   Minimal vanilla JS: money formatting, cart drawer (section re-render),
   menu drawer, predictive search, quantity inputs, recently-viewed store. */
(function () {
  'use strict';

  /* ---------- money ---------- */
  window.formatMoney = function (cents, format) {
    format = format || window.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch (format.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  };

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- menu drawer ---------- */
  var menuDrawer = qs('[data-menu-drawer]');
  qsa('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      menuDrawer.setAttribute('open', '');
      document.body.classList.add('drawer-open');
      btn.setAttribute('aria-expanded', 'true');
    });
  });
  if (menuDrawer) {
    qsa('[data-menu-close]', menuDrawer).forEach(function (el) {
      el.addEventListener('click', function () { menuDrawer.removeAttribute('open'); document.body.classList.remove('drawer-open'); });
    });
    menuDrawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { menuDrawer.removeAttribute('open'); document.body.classList.remove('drawer-open'); }
    });
  }

  /* ---------- cart drawer (server-rendered via Section Rendering API) ---------- */
  function getDrawer() { return qs('[data-cart-drawer]'); }

  function startCartTimer() {
    var el = qs('[data-cart-countdown]');
    if (!el) return;
    clearInterval(window.__hvCartTimer);
    var KEY = 'hv-cart-timer-end';
    var end = parseInt(sessionStorage.getItem(KEY), 10);
    var now = Date.now();
    if (!end || end <= now) {
      end = now + 10 * 60 * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    function tick() {
      var el2 = qs('[data-cart-countdown]');
      if (!el2) { clearInterval(window.__hvCartTimer); return; }
      var left = Math.max(0, end - Date.now());
      if (left === 0) {
        end = Date.now() + 10 * 60 * 1000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
      }
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      el2.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }
    tick();
    window.__hvCartTimer = setInterval(tick, 1000);
  }

  function syncHeaderCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
    qsa('[data-cart-dot]').forEach(function (el) { el.hidden = String(count) === '0'; });
  }

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var cur = getDrawer();
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          cur.setAttribute('data-item-count', fresh.getAttribute('data-item-count') || '0');
          syncHeaderCount(fresh.getAttribute('data-item-count') || '0');
          startCartTimer();
        }
        if (openAfter && cur) {
          cur.setAttribute('open', '');
          document.body.classList.add('drawer-open');
        }
      })
      .catch(function () {});
  }

  function closeCartDrawer() {
    var d = getDrawer();
    if (d) d.removeAttribute('open');
    document.body.classList.remove('drawer-open');
  }

  window.openCartDrawer = function () { refreshCartDrawer(true); };

  window.addToCart = function (formData) {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () { return refreshCartDrawer(true); });
  };

  function changeLine(key, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshCartDrawer(false); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && opener.getAttribute('data-cart-open') === 'drawer') {
      e.preventDefault();
      window.openCartDrawer();
      return;
    }
    var drawer = getDrawer();
    if (!drawer) return;
    if (e.target.closest('[data-cart-close]')) { closeCartDrawer(); return; }
    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
    var qbtn = e.target.closest('[data-line-qty]');
    if (qbtn) {
      changeLine(key, Math.max(0, qty + parseInt(qbtn.getAttribute('data-line-qty'), 10)));
      return;
    }
    if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
  });

  var cartDrawerRoot = getDrawer();
  if (cartDrawerRoot) {
    cartDrawerRoot.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
    startCartTimer();
  }

  /* ---------- predictive search ---------- */
  var searchModal = qs('[data-search-modal]');
  if (searchModal) {
    var searchInput = qs('[data-search-input]', searchModal);
    var searchResults = qs('[data-search-results]', searchModal);
    var searchTimer = null;

    qsa('[data-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        searchModal.setAttribute('open', '');
        searchInput.focus();
      });
    });
    qsa('[data-search-close]', searchModal).forEach(function (el) {
      el.addEventListener('click', function () { searchModal.removeAttribute('open'); });
    });
    searchModal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') searchModal.removeAttribute('open');
    });

    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch(window.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6' + '&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#shopify-section-predictive-search');
            searchResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- quantity inputs (product page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-button]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = qs('.quantity__input', wrap);
    var value = parseInt(input.value, 10) || 1;
    value += btn.getAttribute('data-quantity-button') === 'increase' ? 1 : -1;
    input.value = Math.max(1, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- recently viewed (localStorage) ---------- */
  var KEY = 'heavelyn:recently-viewed';
  window.recentlyViewed = {
    add: function (product) {
      try {
        var list = JSON.parse(localStorage.getItem(KEY) || '[]')
          .filter(function (p) { return p.handle !== product.handle; });
        list.unshift(product);
        localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
      } catch (e) { /* private mode */ }
    },
    get: function () {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    }
  };

  qsa('[data-recently-viewed]').forEach(function (sectionEl) {
    var exclude = sectionEl.getAttribute('data-exclude-handle');
    var items = window.recentlyViewed.get().filter(function (p) { return p.handle !== exclude; }).slice(0, 4);
    if (!items.length) return;
    var grid = qs('[data-recently-viewed-grid]', sectionEl);
    grid.innerHTML = items.map(function (p) {
      var media = p.image
        ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">'
        : '';
      return (
        '<a href="' + p.url + '" class="product-card">' +
          '<div class="product-card__media">' + media + '</div>' +
          '<div class="product-card__row">' +
            '<div><div class="product-card__title">' + p.title + '</div>' +
            (p.meta ? '<div class="product-card__meta">' + p.meta + '</div>' : '') + '</div>' +
            '<div class="product-card__price">' + p.price + '</div>' +
          '</div>' +
        '</a>'
      );
    }).join('');
    sectionEl.removeAttribute('hidden');
  });
})();
